/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export enum SnackbarMessage {
    CLEAR_ALL_CONFIRMATION = 'CLEAR_ALL_CONFIRMATION',
    IMPORT_SUCCESS = 'IMPORT_SUCCESS',
    IMPORT_CANCELLATION = 'IMPORT_CANCELLATION',
    IMPORT_ERROR = 'IMPORT_ERROR',
    IMPORT_WRONG_EXTENSION = 'IMPORT_WRONG_EXTENSION'
}

@Component({
    selector: 'elohn-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarComponent {

    public readonly data = inject<{
    message: SnackbarMessage;
    fileName?: string;
    details?: string;
}>(MAT_SNACK_BAR_DATA);

    public readonly SnackbarMessage = SnackbarMessage;
}
